"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataBox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const enums_1 = require("@bemlo/enums");
const schedule_1 = require("@bemlo/schedule");
const utils_1 = require("@bemlo/utils");
const constants_1 = require("../../constants");
const translate_1 = require("../../translate");
const Flex_1 = require("../Flex");
const Icon_1 = require("../Icon");
const Text_1 = require("../Text");
const isDifferent = (report, previousReport, key) => {
    if (!previousReport)
        return false;
    if (key === 'onCallDisturbances') {
        return ((0, schedule_1.calculateDisturbedTime)(report.onCallDisturbances, 30) !==
            (0, schedule_1.calculateDisturbedTime)(previousReport.onCallDisturbances, 30));
    }
    return report[key] !== previousReport[key];
};
const Container = (0, styled_1.default)(Flex_1.Flex)(({ ml }) => ({
    background: constants_1.Color.LIGHT_GREY,
    borderRadius: constants_1.theme.border.radius.semi,
    padding: constants_1.theme.spacing['2.5'],
    marginLeft: ml,
}));
const KEYS = (0, utils_1.arrayOfAll)()([
    'reportedStartDateTime',
    'reportedEndDateTime',
    'reportedBreakTime',
    'onCallDisturbances',
]);
const DataBox = ({ report, previousReport, ml }) => {
    const t = (0, translate_1.useTranslations)();
    const LABELS = {
        reportedStartDateTime: t.timesheets.start_time(),
        reportedEndDateTime: t.timesheets.end_time(),
        reportedBreakTime: t.timesheets.break_time(),
        onCallDisturbances: t.timesheets.disturbances(),
    };
    const times = KEYS.map((key) => {
        const toLabel = (r) => key === 'reportedBreakTime'
            ? `${r[key]} min`
            : key === 'onCallDisturbances'
                ? t.$n_hours((0, schedule_1.calculateDisturbedTime)(r.onCallDisturbances, 30) / 60, true)
                : t.$date.unix(r[key]).tz('UTC', true).format('HH:mm');
        const hasChanged = isDifferent(report, previousReport, key);
        const hasNoDisturbances = !report.onCallDisturbances.length &&
            !previousReport?.onCallDisturbances.length;
        if (key === 'onCallDisturbances' && hasNoDisturbances)
            return null;
        return {
            key,
            hasChanged,
            toLabel,
            hasNoDisturbances,
        };
    }).filter(utils_1.isTruthy);
    const showTimes = report.status === enums_1.TimeReportStatus.REPORTED ||
        times.some((time) => time.hasChanged);
    if (!showTimes && !report.comment)
        return null;
    return ((0, jsx_runtime_1.jsxs)(Container, { col: true, gap: 1.5, ml: ml, children: [showTimes &&
                times.map(({ key, hasChanged, toLabel }) => {
                    return ((0, jsx_runtime_1.jsxs)(Flex_1.Flex, { gap: 1.5, styles: {
                            color: constants_1.Color.CHARCOAL,
                            justifyContent: 'space-between',
                            fontSize: constants_1.theme.font.size['6.5'],
                        }, children: [(0, jsx_runtime_1.jsx)(Text_1.Text, { children: LABELS[key] }), (0, jsx_runtime_1.jsxs)(Flex_1.Flex, { gap: 1.5, items: "center", children: [hasChanged && previousReport && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Text_1.Text, { color: constants_1.Color.BLUE, styles: {
                                                    textDecoration: 'line-through',
                                                    color: constants_1.Color.DARK_GREY,
                                                }, children: toLabel(previousReport) }), (0, jsx_runtime_1.jsx)(Icon_1.Icon, { size: "sm", name: "ArrowRightIcon" })] })), (0, jsx_runtime_1.jsx)(Text_1.Text, { fontWeight: 600, styles: { minWidth: 40, textAlign: 'right' }, children: toLabel(report) })] })] }, key));
                }), report.comment && ((0, jsx_runtime_1.jsx)(Text_1.Text, { fontSize: constants_1.theme.font.size[6], color: constants_1.Color.DARK_GREY, children: report.comment }))] }));
};
exports.DataBox = DataBox;
